












































































































































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator.ts";

interface dataIngreso {
  rut: string;
  rol: string;
  rol_1: string;
  rol_2: string;
  nombre: string;
  apellido_paterno: string;
  apellido_materno: string;
  fecha_nacimiento: Date | null;
  direccion: string;
  sector: string;
  correo: string;
  telefono: string;
  programa: string;
}

interface selectType {
  value: number | null;
  label: string | null;
}

@Component({
  components: {
    ResultadoComponent: () =>
      import(
        /* webpackPrefetch: true */ "@/components/Formulario/ResultadoComponent.vue"
      )
  }
})
export default class ResultadoPostulacionComponent extends Mixins(
  FormValidator
) {
  private bVerValidador = false;
  private validarRut = false;
  private formattedRut = "";
  private validRut = true;
  private errorType = "";
  private step = "LANDING";
  private dialogRol = false;
  private dataForm: dataIngreso = {
    rut: "",
    rol: "",
    rol_1: "",
    rol_2: "",
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    fecha_nacimiento: null,
    direccion: "",
    sector: "",
    correo: "",
    telefono: "",
    programa: ""
  };
  private carnet: File | null = null;
  private acreditacion: File | null = null;
  private certificado: File | null = null;
  private poder: File | null = null;
  private invalidFileCarnet: boolean = false;
  private invalidFileAcreditacion: boolean = false;
  private invalidFileCertificado: boolean = false;
  private invalidFilePoder: boolean = false;

  @Watch("formattedRut")
  private formatRut(newValue: string) {
    newValue = newValue
      .replace(/\./g, "")
      .replace(/-/g, "")
      .replace(/\s/g, "")
      .toUpperCase();
    this.dataForm.rut = this.rutSanitize(newValue);
    if (newValue.length > 5) {
      const rut = newValue
        .substring(0, newValue.length - 1)
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      const dv = newValue.substring(newValue.length - 1);
      this.formattedRut = `${rut}-${dv}`;
    } else {
      this.formattedRut = newValue
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
        .toUpperCase();
    }
  }

  @Watch("dataSector")
  private watchSector(newValue: any) {
    this.dataForm.sector = newValue.label;
  }

  @Watch("dataPrograma")
  private watchPrograma(newValue: any) {
    if (newValue.value == 1) {
      this.dataForm.programa = "A";
    } else if (newValue.value == 2) {
      this.dataForm.programa = "B";
    } else if (newValue.value == 3) {
      this.dataForm.programa = "C";
    } else if (newValue.value == 4) {
      this.dataForm.programa = "D";
    } else if (newValue.value == 5) {
      this.dataForm.programa = "E";
    } else if (newValue.value == 6) {
      this.dataForm.programa = "F";
    } else if (newValue.value == 7) {
      this.dataForm.programa = "G";
    } else {
      this.dataForm.programa = "";
    }
  }

  @Watch("dataForm.rol_1")
  private watchRol1(newValue: any) {
    this.dataForm.rol = newValue + "-" + this.dataForm.rol_2;
  }
  @Watch("dataForm.rol_2")
  private watchRol2(newValue: any) {
    this.dataForm.rol = this.dataForm.rol_1 + "-" + newValue;
  }

  @Watch("formattedFecha")
  private edadWatcher(newValue: any) {
    const now = new Date(Date.now());
    if (typeof newValue == "object") {
      let day = newValue.getDate();
      let month = newValue.getMonth() + 1;
      let year = newValue.getFullYear();
      if (month < 10) {
        if (day < 10) {
          newValue = `0${day}/0${month}/${year}`;
        } else {
          newValue = `${day}/0${month}/${year}`;
        }
      } else {
        if (day < 10) {
          newValue = `0${day}/${month}/${year}`;
        } else {
          newValue = `${day}/${month}/${year}`;
        }
      }
    }
    var birthDate: any = "";
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1) {
        birthDate = (newValue.substring(6, 10) +
          "-" +
          newValue.substring(3, 5) +
          "-" +
          newValue.substring(0, 2) +
          " 12:00:00") as any;
      } else {
        birthDate = (newValue.substring(6, 10) +
          "-" +
          newValue.substring(3, 5) +
          "-" +
          newValue.substring(0, 2) +
          "T12:00:00") as any;
      }
    }
    let diff;
    if (birthDate instanceof Date) {
      diff = now.getTime() - birthDate.getTime();
      this.dataForm.fecha_nacimiento = birthDate;
    } else {
      diff = now.getTime() - new Date(birthDate).getTime();
      this.dataForm.fecha_nacimiento = new Date(birthDate);
    }
  }

  @Watch("dataForm.nombre")
  private watchNombreUpper(newValue: string) {
    if (newValue != "") {
      this.dataForm.nombre = newValue.toUpperCase();
    }
  }
  @Watch("dataForm.apellido_paterno")
  private watchApellidoPaternoUpper(newValue: string) {
    if (newValue != "") {
      this.dataForm.apellido_paterno = newValue.toUpperCase();
    }
  }
  @Watch("dataForm.apellido_materno")
  private watchApellidoMaternoUpper(newValue: string) {
    if (newValue != "") {
      this.dataForm.apellido_materno = newValue.toUpperCase();
    }
  }
  @Watch("dataForm.direccion")
  private watchDireccioneUpper(newValue: string) {
    if (newValue != "") {
      this.dataForm.direccion = newValue.toUpperCase();
    }
  }
  @Watch("dataForm.correo")
  private watchCorreoUpper(newValue: string) {
    if (newValue != "") {
      this.dataForm.correo = newValue.toUpperCase();
    }
  }

  private mounted() {
    this.verValidador("rut");
  }

  private verValidador(tipo: string) {
    if (tipo == "rut") {
      this.validarRut = true;
    } else {
      this.validarRut = false;
    }
    this.bVerValidador = true;
  }

  private volver() {
    this.$router.push({ name: "Home" }).catch(err => {});
  }

  private verFormulario() {
    this.bVerValidador = false;
    this.step = "FORMULARIO";
    window.scrollTo(0, 0);
  }

  private validarInicio() {
    let path = "";
    if (this.validarRut) {
      if (this.dataForm.rut.replace(/\s/g, "") == "") {
        Notify.create({
          color: "negative",
          message: "Debe completar el Rut",
          icon: "report_problem",
          position: "top",
          timeout: 3500
        });
        return;
      }
      if (!this.validateRut(this.dataForm.rut)) {
        Notify.create({
          color: "negative",
          message: "Debe ingresar un Rut válido",
          icon: "report_problem",
          position: "top",
          timeout: 3500
        });
        return;
      }
      path = "?rut=" + this.dataForm.rut;
    } else {
      if (
        this.dataForm.rol_1.replace(/\s/g, "") == "" ||
        this.dataForm.rol_2.replace(/\s/g, "") == ""
      ) {
        Notify.create({
          color: "negative",
          message: "Debe completar el Rol",
          icon: "report_problem",
          position: "top",
          timeout: 3500
        });
        return;
      } else {
        this.dataForm.rol = this.dataForm.rol_1 + "-" + this.dataForm.rol_2;
      }
      path = "?rol=" + this.dataForm.rol;
    }
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("/postulacion/aseo" + path)
      .then((res: any) => {
        if (res.data.message == "SUCCESS") {
          this.dataForm.nombre = res.data.data.nombre;
          this.errorType = "RENOVADO";
        } else if (res.data.message == "SUCCESS_POSTULACION") {
          this.dataForm.nombre = res.data.data.nombre;
          this.errorType = "SUCCESS_POSTULACION";
        } else if (res.data.message == "RECHAZADO") {
          if (this.validarRut) {
            this.dataForm.nombre = "RUT";
          } else {
            this.dataForm.nombre = "ROL";
          }
          this.errorType = "RECHAZADO";
        } else {
          if (res.data.message == "NO_REGISTRADO") {
            if (this.validarRut) {
              this.dataForm.nombre = "RUT";
            } else {
              this.dataForm.nombre = "ROL";
            }
            this.errorType = "NO_BENEFICIADO";
          } else {
            if (this.$router.currentRoute.name == "formularioTerminado") {
              this.$router.go(0);
            } else {
              this.$router
                .push({ name: "formularioTerminado" })
                .catch(err => {});
            }
          }
        }
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        if (err.response.data.message == "REGISTRADO") {
          let mensaje = "Ha ocurrido un error, intentelo nuevamente";
          if (this.validarRut) {
            mensaje = "El Rut ingresado ya cuenta con una postulación";
          } else {
            mensaje = "El Rol ingresado ya cuenta con una postulación";
          }
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message: mensaje,
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        } else if (err.response.data.message == "RECHAZADO") {
          if (this.validarRut) {
            this.dataForm.nombre = "RUT";
          } else {
            this.dataForm.nombre = "ROL";
          }
          this.errorType = "RECHAZADO";
        } else if (err.response.data.message == "EN_REVISION") {
          if (this.validarRut) {
            this.dataForm.nombre = "RUT";
          } else {
            this.dataForm.nombre = "ROL";
          }
          this.errorType = "EN_REVISION";
        } else {
          // Error
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message: "Ha ocurrido un error, intentelo nuevamente",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        }
      });
  }
  private rutSanitize(rut: string) {
    const temp = rut.replace(/\./g, "").replace(/-/g, "");
    const rutNumber = temp.substring(0, temp.length - 1);
    const dv = temp.substring(temp.length - 1);
    return `${rutNumber}-${dv}`;
  }
  private validEmail(email: any) {
    // eslint-disable-next-line
    let emailRegex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegex.test(email) === true) {
      return true;
    } else {
      return false;
    }
  }
  public validateRut(newValue: string) {
    var texto = newValue;
    var tmpstr = "";
    for (let i = 0; i < texto.length; i++)
      if (
        texto.charAt(i) != " " &&
        texto.charAt(i) != "." &&
        texto.charAt(i) != "-"
      )
        tmpstr = tmpstr + texto.charAt(i);
    texto = tmpstr;
    var largo = texto.length;
    if (largo < 2) {
      this.validRut = false;
      return false;
    }
    for (let i = 0; i < largo; i++) {
      if (
        texto.charAt(i) != "0" &&
        texto.charAt(i) != "1" &&
        texto.charAt(i) != "2" &&
        texto.charAt(i) != "3" &&
        texto.charAt(i) != "4" &&
        texto.charAt(i) != "5" &&
        texto.charAt(i) != "6" &&
        texto.charAt(i) != "7" &&
        texto.charAt(i) != "8" &&
        texto.charAt(i) != "9" &&
        texto.charAt(i) != "k" &&
        texto.charAt(i) != "K"
      ) {
        this.validRut = false;
        return false;
      }
    }
    var invertido = "";
    for (let i = largo - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + texto.charAt(i);
    var dtexto = "";
    dtexto = dtexto + invertido.charAt(0);
    dtexto = dtexto + "-";
    var cnt = 0;
    for (let i = 1, j = 2; i < largo; i++, j++) {
      //alert("i=[" + i + "] j=[" + j +"]" );
      if (cnt == 3) {
        dtexto = dtexto + ".";
        j++;
        dtexto = dtexto + invertido.charAt(i);
        cnt = 1;
      } else {
        dtexto = dtexto + invertido.charAt(i);
        cnt++;
      }
    }
    invertido = "";
    for (let i = dtexto.length - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + dtexto.charAt(i);

    if (this.revisarDigito2(texto)) {
      this.validRut = true;
      return true;
    }
    this.validRut = false;
    return false;
  }
  public revisarDigito(dvr: string) {
    var dv = dvr + "";
    if (
      dv != "0" &&
      dv != "1" &&
      dv != "2" &&
      dv != "3" &&
      dv != "4" &&
      dv != "5" &&
      dv != "6" &&
      dv != "7" &&
      dv != "8" &&
      dv != "9" &&
      dv != "k" &&
      dv != "K"
    ) {
      return false;
    }
    return true;
  }
  public revisarDigito2(crut: string) {
    var largo = crut.length;
    if (largo < 2) {
      return false;
    }
    if (largo > 2) var rut = crut.substring(0, largo - 1);
    else rut = crut.charAt(0);
    var dv = crut.charAt(largo - 1);
    this.revisarDigito(dv);
    if (rut == null || dv == null) return 0;
    var dvr = "0";
    var suma = 0;
    var mul = 2;
    for (let i = rut.length - 1; i >= 0; i--) {
      suma = suma + parseInt(rut.charAt(i), 10) * mul;
      if (mul == 7) mul = 2;
      else mul++;
    }
    var res = suma % 11;
    if (res == 1) dvr = "k";
    else if (res == 0) dvr = "0";
    else {
      var dvi = 11 - res;
      dvr = dvi + "";
    }
    if (dvr != dv.toLowerCase()) {
      return false;
    }
    return true;
  }
  private checkFecha(d: any) {
    if (Object.prototype.toString.call(d) === "[object Date]") {
      // it is a date
      if (isNaN(d.getTime())) {
        // d.valueOf() could also work
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  private enviarForm() {
    if (this.dataForm.rut.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe completar el Rut",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (!this.validateRut(this.dataForm.rut)) {
      Notify.create({
        color: "negative",
        message: "Debe ingresar un Rut válido",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (this.dataForm.programa.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe seleccionar un Tipo de Postulación",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (
      this.dataForm.rol_1.replace(/\s/g, "") == "" ||
      this.dataForm.rol_2.replace(/\s/g, "") == ""
    ) {
      Notify.create({
        color: "negative",
        message: "Debe Ingresar un Rol de Propiedad",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (this.dataForm.nombre.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe completar el Nombre",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (this.dataForm.apellido_paterno.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe completar el Apellido Paterno",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (
      this.dataForm.fecha_nacimiento == null ||
      !this.checkFecha(this.dataForm.fecha_nacimiento)
    ) {
      Notify.create({
        color: "negative",
        message: "Ingrese una fecha de nacimiento válida (formato DD/MM/AAAA)",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (this.dataForm.direccion.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe completar la dirección",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (
      !this.dataForm.sector ||
      this.dataForm.sector.replace(/\s/g, "") == ""
    ) {
      Notify.create({
        color: "negative",
        message: "Debe seleccionar el sector de procedencia",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (
      !this.validEmail(this.dataForm.correo) ||
      this.dataForm.correo.replace(/\s/g, "") == ""
    ) {
      Notify.create({
        color: "negative",
        message: "Debe ingresar un correo válido",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (this.dataForm.telefono.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe ingresar un teléfono",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (this.dataForm.telefono.length < 9) {
      Notify.create({
        color: "negative",
        message: "Debe ingresar un teléfono válido (9 dígitos)",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }

    if (this.carnet == null || this.invalidFileCarnet == true) {
      Notify.create({
        color: "negative",
        message: "Debe agregar una carnet válido",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }
    if (this.acreditacion == null || this.invalidFileAcreditacion == true) {
      Notify.create({
        color: "negative",
        message: "Debe ingresar una Acreditación de vivienda",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }
    if (this.dataForm.programa == "C" || this.dataForm.programa == "D") {
      if (this.certificado == null || this.invalidFileCertificado == true) {
        let mensaje = "Ha ocurrido un error, intentelo nuevamente";
        if (this.dataForm.programa == "C") {
          mensaje = "Debe ingresar un Certificado de Discapacidad";
        } else {
          mensaje =
            "Debe ingresar un Certificado que acredite la invalidez de carácter total del familiar";
        }
        Notify.create({
          color: "negative",
          message: mensaje,
          icon: "report_problem",
          position: "top",
          timeout: 3500
        });
        return;
      }
    }
    const data = new FormData();
    if (this.carnet) {
      const ciFile = this.carnet as Blob;
      data.append("carnet", ciFile);
    } else {
      const ciFile = new File(["file"], "Carnet") as Blob;
      data.append("carnet", ciFile);
    }
    if (this.acreditacion) {
      const acFile = this.acreditacion as Blob;
      data.append("acreditacion", acFile);
    } else {
      const acFile = new File(["file"], "Acreditación") as Blob;
      data.append("acreditacion", acFile);
    }
    if (this.dataForm.programa == "C" || this.dataForm.programa == "D") {
      if (this.certificado) {
        const acFile = this.certificado as Blob;
        data.append("certificado", acFile);
      } else {
        const acFile = new File(["file"], "Certificado") as Blob;
        data.append("certificado", acFile);
      }
    }
    if (this.poder) {
      const ciFile = this.poder as Blob;
      data.append("poder", ciFile);
    } else {
      const ciFile = new File(["file"], "Poder") as Blob;
      data.append("poder", ciFile);
    }
    for (const prop in this.dataForm) {
      if (this.dataForm.hasOwnProperty(prop)) {
        // @ts-ignore
        if (this.dataForm[prop] || this.dataForm[prop] === 0) {
          // @ts-ignore
          data.append(prop, this.dataForm[prop]);
        }
      }
    }
    if (this.dataForm.apellido_materno == "") {
      data.append("apellido_materno", "");
    }
    if (this.dataForm.correo == "") {
      data.append("correo", "");
    }
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .post("/formulario/aseo", data)
      .then((res: any) => {
        this.$q.loading.hide();
        this.errorType = "SUCCESS";
      })
      .catch((err: any) => {
        if (err.response.data.message == "RUT_REGISTRADO") {
          this.$q.loading.hide();
          // Error
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message:
              "El Rut ingresado ya se encuentra registrado en una postulación",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        } else if (err.response.data.message == "ROL_REGISTRADO") {
          this.$q.loading.hide();
          // Error
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message:
              "El Rol ingresado ya se encuentra registrado en una postulación",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        } else if (err.response.data.message == "RUT_RENOVADO") {
          this.$q.loading.hide();
          // Error
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message:
              "El Rut ingresado fue renovado automáticamente y no necesita postular",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        } else if (err.response.data.message == "ROL_RENOVADO") {
          this.$q.loading.hide();
          // Error
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message:
              "El Rol ingresado fué renovado automáticamente y no necesita postular",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        } else {
          this.$q.loading.hide();
          // Error
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message: "Ha ocurrido un error, intentelo nuevamente",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        }
      });
  }
  private checkFileCarnet(target: HTMLInputElement) {
    let flag = false;
    const extensions = ["jpg", "jpeg", "png", "pdf", "docx", "doc"];
    if (target.files && target.files[0]) {
      for (const x in extensions) {
        if (target.files[0].type.includes(extensions[x])) {
          flag = true;
        }
      }
      if (target.files[0].size > 10 * 1024 * 1024 || !flag) {
        this.invalidFileCarnet = true;
        Notify.create({
          color: "negative",
          message: "El archivo sobrepasa el máximo permitido (5mb)",
          icon: "report_problem",
          position: "top",
          timeout: 4000
        });
        return;
      } else if (target.files[0].size <= 0 || !flag) {
        this.invalidFileCarnet = true;
      } else {
        this.carnet = target.files[0];
        this.invalidFileCarnet = false;
      }
    }
  }
  private checkFileAcreditacion(target: HTMLInputElement) {
    let flag = false;
    const extensions = ["jpg", "jpeg", "png", "pdf", "docx", "doc"];
    if (target.files && target.files[0]) {
      for (const x in extensions) {
        if (target.files[0].type.includes(extensions[x])) {
          flag = true;
        }
      }
      if (target.files[0].size > 10 * 1024 * 1024 || !flag) {
        this.invalidFileAcreditacion = true;
        Notify.create({
          color: "negative",
          message: "El archivo sobrepasa el máximo permitido (5mb)",
          icon: "report_problem",
          position: "top",
          timeout: 4000
        });
        return;
      } else if (target.files[0].size <= 0 || !flag) {
        this.invalidFileAcreditacion = true;
      } else {
        this.acreditacion = target.files[0];
        this.invalidFileAcreditacion = false;
      }
    }
  }
  private checkFileCertificado(target: HTMLInputElement) {
    let flag = false;
    const extensions = ["jpg", "jpeg", "png", "pdf", "docx", "doc"];
    if (target.files && target.files[0]) {
      for (const x in extensions) {
        if (target.files[0].type.includes(extensions[x])) {
          flag = true;
        }
      }
      if (target.files[0].size > 10 * 1024 * 1024 || !flag) {
        this.invalidFileCertificado = true;
        Notify.create({
          color: "negative",
          message: "El archivo sobrepasa el máximo permitido (5mb)",
          icon: "report_problem",
          position: "top",
          timeout: 4000
        });
        return;
      } else if (target.files[0].size <= 0 || !flag) {
        this.invalidFileCertificado = true;
      } else {
        this.certificado = target.files[0];
        this.invalidFileCertificado = false;
      }
    }
  }
  private checkFilePoder(target: HTMLInputElement) {
    let flag = false;
    const extensions = ["jpg", "jpeg", "png", "pdf", "docx", "doc"];
    if (target.files && target.files[0]) {
      for (const x in extensions) {
        if (target.files[0].type.includes(extensions[x])) {
          flag = true;
        }
      }
      if (target.files[0].size > 10 * 1024 * 1024 || !flag) {
        this.invalidFilePoder = true;
        Notify.create({
          color: "negative",
          message: "El archivo sobrepasa el máximo permitido (5mb)",
          icon: "report_problem",
          position: "top",
          timeout: 4000
        });
        return;
      } else if (target.files[0].size <= 0 || !flag) {
        this.invalidFilePoder = true;
      } else {
        this.poder = target.files[0];
        this.invalidFilePoder = false;
      }
    }
  }
}
